import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  display: flex;
  height: 60px;

  background-color: ${colors.primary};
`

export const Separator = styled.div`
  height: 32px;
  width: 1px;
  align-self: center;
  border: none;
  background-color: ${colors.titleStrongWhite}1F;
`

export const Title = styled.div`
  color: ${colors.titleStrongWhite};
  font-family: Circular-Std-Bold;
  padding: 0 24px;
  align-self: center;

  @media (max-width: 600px) {
    font-size: 12px;
    text-align: center;
  }

  @media (max-width: 445px) {
    font-size: 10px;
  }
`
